import _ from 'lodash';
import React from 'react';

import { useNetSuiteEmployeeSelectFieldQuery } from 'generated/graphql';



export interface INetSuiteEmployee {
  id: string;
  displayName: string;
}

export interface IData {
  objects: INetSuiteEmployee[];
}

export function useQuery() {
  const queryTuple = useNetSuiteEmployeeSelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.employees ?? [], (node): INetSuiteEmployee => ({
        id: node.id,
        displayName: node.fullName
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
